import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronRight, CloseIcon } from '../../assets/icons';
import { accountDeactivationAction, featchAccountStatusAction } from '../../store/reducer/accountActivationSlice';
import { matchRoutes, useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { Modal, Row, Col, Button, Spin } from 'antd';

import AccountNav from '../../components/AccountNav/AccountNav';
import AccountNavMobile from '../../components/AccountNavMobile/AccountNavMobile';
import LegalSidebar from '../../components/LegalSidebar/LegalSidebar';
import LegalSidebarMobile from '../../components/LegalSidebarMobile/LegalSidebarMobile';
import PolicyDetails from './PolicyDetails';
import { resetUserData } from '../../store/reducer/accountSlice';

import { Images } from '../../config/images';
import './Legal.scss';

import useLegal from '../../Hooks/useLegal';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Legal = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [screen, setScreen] = useState('default');
  const [deleteModal, setDeleteModal] = useState(false);
  const [sellState, setSellState] = useState(0);

  const { isLoading = false, policyTypesList, fetchPolicyByEnum, isFetchingPolicy = true, policyDetails } = useLegal({ shouldFetchTypes: true });

  const accountStatusData = useSelector((state) => state.accountActivation.data);
  const context = useOutletContext();
  const isLegalPath = matchRoutes([{ path: '/legal' }], location.pathname);
  const isAccountLegal = matchRoutes([{ path: '/account/legal' }], location.pathname);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.accountActivation.loading);

  useEffect(() => {
    isAccountLegal && handleFeatchAccountStatus();
  }, []);

  const handleFeatchAccountStatus = async () => {
    await dispatch(featchAccountStatusAction({}));
  };

  const handleSetState = async () => {
    if (accountStatusData?.data?.hasOpenOrders || accountStatusData?.data?.hasShares) {
      navigate('/portfolio');
    } else if (accountStatusData?.data?.hasBalanceInWallet) {
      navigate('/account/transactions?openTransection=true');
    } else {
      await dispatch(
        accountDeactivationAction({
          onSuccess: async () => {
            await localStorage.clear();
            await dispatch(resetUserData());
            navigate('/login');
          },
        })
      );
      //api call
    }
  };

  const PolicyListing = () => {
    return (
      <div>
        {screen === 'default' ? (
          <>
            <h4>Data and Privacy</h4>
            <Spin spinning={isLoading}>
              <div className='mb-24 legal__options'>
                {policyTypesList?.map((policy) => (
                  <div
                    className='legal__options__item'
                    onClick={() => {
                      navigate(
                        {
                          pathname: `/account/legal`,
                          hash: policy,
                        },
                        { replace: true }
                      );
                    }}
                    key={policy}
                  >
                    <p>{policy}</p>
                    <ChevronRight size={24} />
                  </div>
                ))}
              </div>
            </Spin>
            <p className='text-terracotta fw-600 cursor-pointer' onClick={() => setDeleteModal(true)}>
              Deactivate my account
            </p>
          </>
        ) : (
          <PolicyDetails title={screen} isFetchingList={isLoading} isLoading={isFetchingPolicy} policyDetails={policyDetails} />
        )}
      </div>
    );
  };

  useEffect(() => {
    if (location.pathname === '/account/legal') {
      const hash = decodeURIComponent(location.hash?.replace('#', ''));

      if (policyTypesList?.length) {
        if (location.hash) {
          if (policyTypesList?.indexOf(hash) === -1) {
            setScreen('default');
            navigate({ pathname: location.pathname, hash: '' }, { replace: true });
            return;
          }
          setScreen(hash);
        } else {
          setScreen('default');
        }
      }
    }
  }, [location.pathname, location.hash, policyTypesList]);

  useEffect(() => {
    const hash = decodeURIComponent(location.hash?.replace('#', ''));
    const navigateToDefault = () => {
      policyTypesList?.[0] &&
        navigate(
          {
            pathname: `/legal`,
            hash: policyTypesList?.[0],
          },
          { replace: true }
        );
    };

    if (location.pathname === '/legal') {
      if (policyTypesList?.length) {
        if (policyTypesList?.indexOf(hash) === -1) {
          navigateToDefault();
          return;
        }
        if (location.hash) {
          setScreen(hash);
        } else {
          navigateToDefault();
        }
      }
    }
  }, [location.pathname, location.hash, policyTypesList]);

  useEffect(() => {
    if (isAccountLegal) {
      if (screen !== 'default') {
        context?.setSidebarVisible(false);
      } else {
        context?.setSidebarVisible(true);
      }
    }

    if (screen !== 'default') {
      fetchPolicyByEnum(screen);
    }
  }, [screen]);

  const setActiveScreen = (value) => {
    navigate(
      {
        pathname: `/legal`,
        hash: value,
      },
      { replace: true }
    );
  };

  // const errMsg = 'Finish setting up your account to begin investing with Realbricks';
  // return (
  //   <div className='legal'>
  //     {/* <div className='legal__body'> */}
  //     {screen !== 'default' && (
  //       <div>
  //         <p onClick={() => setScreen('default')} className='text-copper fw-600 cursor-pointer mb-32'>
  //           <ArrowLeft verticalAlign='-6px' /> Back
  //         </p>
  //       </div>
  //     )}
  // const errMsg = 'Finish setting up your account to begin investing with Realbricks';
  return (
    <div className='legal'>
      {isLegalPath && (
        <>
          <div className='sticky-nav'>
            <AccountNav />
          </div>
          <AccountNavMobile />
          <LegalSidebarMobile policiesList={policyTypesList} isLoading={isLoading} activeScreen={screen} setActiveScreen={setActiveScreen} />
        </>
      )}
      {isLegalPath && (
        <div className='legal__body'>
          <div>
            <LegalSidebar policiesList={policyTypesList} isLoading={isLoading} activeScreen={screen} setActiveScreen={setActiveScreen} />
          </div>
          {screen !== 'default' && (
            <PolicyDetails title={screen} isFetchingList={isLoading} isLoading={isFetchingPolicy} policyDetails={policyDetails} />
          )}
        </div>
      )}

      {isAccountLegal && (
        <div>
          <PolicyListing />
        </div>
      )}
      <Modal
        className='delete-account'
        open={deleteModal && sellState < 4}
        footer={false}
        width={524}
        closeIcon={<CloseIcon />}
        onCancel={() => setDeleteModal(false)}
        centered
      >
        <div className='text-center mb-16'>
          <LazyLoadImage src={Images.deleteAccount} alt='user icon with strike through line' />
        </div>
        <h4 className='text-center'>Deactivate your account</h4>
        <p className='text-taupe mb-20'>
        Before you can proceed, you must complete the following actions. Canceling and/or selling shares can be done from within your Portfolio.
        </p>
        <div className='delete-item'>
          <span>Cancel all Realbricks Market orders.</span>
          {!accountStatusData?.data?.hasOpenOrders ? (
            <span className='fw-600 fz-14'>Complete</span>
          ) : (
            <span className='text-error fw-600 fz-14'>Incomplete</span>
          )}
        </div>
        <div className='delete-item'>
          <span>Sell all of your shares.</span>
          {!accountStatusData?.data?.hasShares ? (
            <span className='fw-600 fz-14'>Complete</span>
          ) : (
            <span className='text-error fw-600 fz-14'>Incomplete</span>
          )}
        </div>
        <div className='delete-item'>
          <span>Transfer all funds to your bank.</span>
          {!accountStatusData?.data?.hasBalanceInWallet ? (
            <span className='fw-600 fz-14'>Complete</span>
          ) : (
            <span className='text-error fw-600 fz-14'>Incomplete</span>
          )}
        </div>
        <p className='mb-48 mt-20'>
          We will retain your <span className='fw-600'>user data</span> for up to <span className='fw-600'>6 months</span> before permanently deleting it. A record of all investments will be retained as required by law.
        </p>
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12}>
            <Button onClick={() => setDeleteModal(false)} className='w-100'>
              Cancel
            </Button>
          </Col>
          <Col span={24} sm={12}>
            <Button loading={loading} className='w-100 px-0' type='primary' danger onClick={() => handleSetState()}>
              {(accountStatusData?.data?.hasOpenOrders || accountStatusData?.data?.hasShares) && <>Go to portfolio</>}
              {(!accountStatusData?.data?.hasOpenOrders || !accountStatusData?.data?.hasShares) && accountStatusData?.data?.hasBalanceInWallet && (
                <>Transfer funds</>
              )}
              {!accountStatusData?.data?.hasOpenOrders && !accountStatusData?.data?.hasShares && !accountStatusData?.data?.hasBalanceInWallet && (
                <>Deactivate Account</>
              )}
            </Button>
          </Col>
        </Row>
      </Modal>
      <Modal
        className='delete-account'
        open={sellState >= 4}
        footer={false}
        width={524}
        closeIcon={<CloseIcon />}
        onCancel={() => setSellState(0)}
        centered
      >
        <div className='text-center mb-16'>
          <LazyLoadImage src={Images.deleteAccount} alt='user icon with strike through line' />
        </div>
        <h4 className='text-center mb-16'>Unable to deactivate your account</h4>
        <p className='mb-48'>
          Due to a pending buy order, we are unable to deactivate your account at this time. To proceed with account deactivation you must wait for
          the order to finalize, or cancel the order entirely.
        </p>
        <Button
          className='w-100'
          onClick={() => {
            setSellState(0);
          }}
        >
          Done
        </Button>
      </Modal>
    </div>
  );
};

export default Legal;